import { Component, HostBinding, Input } from '@angular/core';
import { AbsenceWithPeriodSumModel } from '@reducers/orm/absence/absence.model';
import { PlanType } from '@shiftbase-com/ts-shared/models';

@Component({
  standalone: false,
  selector: 'timesheet-total-absence',
  templateUrl: './timesheet-total-absence.component.html',
})
export class TimesheetTotalAbsenceComponent {
  @Input()
  absence: AbsenceWithPeriodSumModel;
  @Input()
  showTotals = true;
  @Input()
  showSalary: boolean;
  @Input()
  coc: number;
  @Input()
  showCoc = false;

  @HostBinding('style.height.px')
  height = 36;

  planType = PlanType;
}
